var _mask, _path, _mask2, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyRecomp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25242_4463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_25242_4463",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V25H25V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H0V25H25V0Z",
    fill: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_25242_4463)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25242_4463)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25242_4463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_25242_4463",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.24792e-05H24.9999V25H0V7.24792e-05Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.24792e-05H24.9999V25H0V7.24792e-05Z",
    fill: "white",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_25242_4463)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25242_4463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05356 7.19266H4.39014C4.09321 7.19266 3.85254 7.43338 3.85254 7.73025V17.27C3.85254 17.5669 4.09321 17.8076 4.39014 17.8076H5.05356C5.35048 17.8076 5.59116 17.5669 5.59116 17.27V7.73025C5.59116 7.43338 5.35048 7.19266 5.05356 7.19266Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31533 8.53401H2.6519C2.35498 8.53401 2.11426 8.77473 2.11426 9.0716V15.9282C2.11426 16.2251 2.35498 16.4658 2.6519 16.4658H3.31533C3.61225 16.4658 3.85292 16.2251 3.85292 15.9282V9.0716C3.85292 8.77473 3.61225 8.53401 3.31533 8.53401Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11401 11.6308H0.904784C0.607861 11.6308 0.367188 11.8714 0.367188 12.1684V12.8318C0.367188 13.1287 0.607861 13.3694 0.904784 13.3694H2.11401V11.6308Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2075 5.84281H18.8709C19.1679 5.84281 19.4086 6.08349 19.4086 6.38041V18.6196C19.4086 18.9165 19.1679 19.1572 18.8709 19.1572H18.2075C17.9106 19.1572 17.6699 18.9165 17.6699 18.6196V6.38041C17.6699 6.08349 17.9106 5.84281 18.2075 5.84281Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9468 7.19266H20.6102C20.9071 7.19266 21.1478 7.43338 21.1478 7.73025V17.27C21.1478 17.5669 20.9071 17.8076 20.6102 17.8076H19.9468C19.6499 17.8076 19.4092 17.5669 19.4092 17.27V7.73025C19.4092 7.43338 19.6499 7.19266 19.9468 7.19266Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6851 8.53401H22.3485C22.6454 8.53401 22.8861 8.77473 22.8861 9.0716V15.9282C22.8861 16.2251 22.6454 16.4658 22.3485 16.4658H21.6851C21.3881 16.4658 21.1475 16.2251 21.1475 15.9282V9.0716C21.1475 8.77473 21.3881 8.53401 21.6851 8.53401Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8867 11.6308H24.0959C24.3929 11.6308 24.6335 11.8714 24.6335 12.1684V12.8318C24.6335 13.1287 24.3929 13.3694 24.0959 13.3694H22.8867V11.6308Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96992 11.6308H7.33008V13.3694H9.68232C9.32661 12.8703 9.05634 12.2898 8.96992 11.6308Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0304 11.6308C15.9439 12.2896 15.6738 12.8701 15.3184 13.3694H17.6703V11.6308H16.0304Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4785 9.59069C13.1644 9.74988 12.9043 9.99827 12.7308 10.3047L12.7307 10.3046C12.5997 10.4668 12.3988 10.4661 12.2684 10.305L12.2682 10.3051C11.9618 9.76623 11.3828 9.4027 10.7186 9.40334C9.73545 9.40436 8.93945 10.2021 8.94043 11.1852C8.94331 14.0676 12.5049 15.6001 12.5049 15.6001C12.5049 15.6001 16.0635 14.0604 16.0607 11.1779C16.0599 10.5268 15.7096 9.95798 15.1875 9.64816",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33046 15.1054V6.38046C7.33046 6.08354 7.08974 5.84281 6.79287 5.84281H6.12939C5.83252 5.84281 5.5918 6.08354 5.5918 6.38046V18.6196C5.5918 18.9166 5.83252 19.1572 6.12939 19.1572H6.79287C7.08974 19.1572 7.33046 18.9166 7.33046 18.6196V16.8144",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyRecomp);
export default __webpack_public_path__ + "static/media/BodyRecomp.06021c6d35700a65c049c2e2882595a9.svg";
export { ForwardRef as ReactComponent };